<div class='gov-spinner-container'>
  <div class="gov-spinner">
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
    <div class="gov-spinner__dot"></div>
  </div>
  <p>
    <strong>
      <ng-content></ng-content>
    </strong>
  </p>
</div>
